import React from "react";
import { Trash2, CalendarClock } from "lucide-react";

const fmtDoli = (ts) => (ts ? new Date(Number(ts) * 1000).toLocaleString("fr-FR") : "—");

export const AppointmentCard = ({ a, prospectName, onRemove }) => (
  <div className="bg-white border border-neutral-200 rounded-xl p-4 flex items-center justify-between" data-testid={`appt-card-${a.id}`}>
    <div className="flex items-start gap-3">
      <div className="bg-brand/10 text-brand rounded-lg p-2.5"><CalendarClock size={18} /></div>
      <div>
        <p className="font-semibold text-neutral-900">{a.titre}</p>
        <p className="text-sm text-neutral-600">{new Date(a.date).toLocaleString("fr-FR")} · {prospectName}</p>
        <div className="flex items-center gap-2 flex-wrap mt-0.5">
          {a.status === "confirme" && <span className="text-xs font-semibold bg-emerald-600 text-white px-2 py-0.5 rounded-full" data-testid={`appt-confirmed-${a.id}`}>Confirmé</span>}
          {a.status === "annule" && <span className="text-xs font-semibold bg-neutral-200 text-neutral-600 px-2 py-0.5 rounded-full">Annulé</span>}
          {a.major_nom && <span className="text-xs font-semibold bg-brand/10 text-brand px-2 py-0.5 rounded-full" data-testid={`appt-major-${a.id}`}>Major : {a.major_nom}</span>}
          {a.source === "mail_agent" && <span className="text-xs font-semibold bg-violet-100 text-violet-700 px-2 py-0.5 rounded-full">Agent mail</span>}
          {a.dolibarr_event_id && <span className="text-xs text-emerald-600">✓ Dolibarr #{a.dolibarr_event_id}</span>}
        </div>
        {a.notes && <p className="text-sm text-neutral-500 mt-1">{a.notes}</p>}
      </div>
    </div>
    <button onClick={() => onRemove(a.id)} className="text-neutral-400 hover:text-red-500 p-1.5" data-testid={`appt-delete-${a.id}`}><Trash2 size={17} /></button>
  </div>
);

export const DolibarrEventCard = ({ e }) => (
  <div className="bg-white border border-neutral-200 rounded-xl p-4">
    <div className="flex items-start gap-3">
      <div className="bg-emerald-50 text-emerald-600 rounded-lg p-2.5"><CalendarClock size={18} /></div>
      <div>
        <p className="font-semibold text-neutral-900">{e.label || "Événement"}</p>
        <p className="text-sm text-neutral-600">{fmtDoli(e.datep)}</p>
        {e.note && <p className="text-sm text-neutral-500 mt-1">{e.note}</p>}
      </div>
    </div>
  </div>
);
